import { Component, Input } from '@angular/core';
import { module } from 'app/modules/equipment-registration/equipment-registration.module';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  standalone: true,
  imports: module,
  styleUrls: ['./form.component.scss']
})
export class FormComponent {
  @Input() data: any
  @Input() formName: string | null

  ngOnInit()
  {}
}
